export default "__VITE_PUBLIC_ASSET__5905a5d3__"